import React from "react";
import { MobileMenu } from "../HeaderMobileMenu/HeaderMobileMenu";
import { HeaderLogo } from "../HeaderLogoBlock/HeaderLogoBlock";
import { HeaderMenu } from "../HeaderMenu/HeaderMenu";
import { HeaderActions } from "../HeaderActions/HeaderActions";
import { TextField } from "@arctheme-components/elements/TextField/TextField";

export default function HeaderSplit2RowLeft({
  links,
  item_count = "",
  settings,
}) {
  return (
    <div className={"header-rows"}>
      <div className={"header-row"}>
        <HeaderLogo settings={settings} />
        <div className={"header-search"}>
          <TextField id={"search"} placeholder={"Search..."} value={""} />
        </div>
        <HeaderActions item_count={item_count} settings={settings} />
      </div>
      <div className={`header-row`}>
        <MobileMenu link_list={links} settings={settings} />
        <HeaderMenu link_list={links} settings={settings} />
      </div>
    </div>
  );
}
